import * as ActionTypes from '../action-types'

const vehicleReport_DefaultState = {
    reportByVID: {},
    allVIDs: []
}

export const vehicleReport = (state = vehicleReport_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_VEHICLE_UTILISATION_REPORTS: {

            const report = action.report
            const vid = action.vid

            if(vid) {

                newState.reportByVID[vid] = report

                if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

            }

            return newState
        }
        case ActionTypes.CLEAR_VEHICLE_UTILISATION_REPORTS: {

            newState.reportByVID = {}
            newState.allVIDs = []

            return newState;
        }
        default: {
            return newState;
        }
    }
}